export default __webpack_public_path__ + "dbd13d7361f6296ceae9a3eed4d62065.png";